export const parseList = (response) => {
  if (response.status !== 200) throw Error(response.message);
  if (!response.data) return [];
  let list = response.data.data;
  if (typeof list !== "object") {
    list = [];
  }
  return list;
};

export const parseBlob = (response) => {
  if (response.status !== 200) throw Error(response.message);
  // if (!response.data) return [];
  var fileURL = window.URL.createObjectURL(new Blob([response.data]));
  // let list = response.data.data;
  // if (typeof list !== "object") {
  //   list = [];
  // }
  return fileURL;
};

export const dateFormat = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [year, month, day].join("-");
};

export const setExpireDate = (date, months) => {
  var d = new Date(date);
  // console.log(months);
  // console.log(d.getMonth()+1 + months);
  var newdate = new Date(d.setMonth(d.getMonth() + months));
  return newdate;
};

export const numberFormat = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
